import React from 'react'

export default function DogLogo({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      className="flex-shrink-0"
    >
      {/* Dog Body */}
      <ellipse cx="100" cy="140" rx="50" ry="35" fill="#8B4513" />

      {/* Dog Head */}
      <circle cx="100" cy="85" r="40" fill="#8B4513" />

      {/* Snout */}
      <ellipse cx="100" cy="100" rx="25" ry="18" fill="#A0522D" />

      {/* Nose */}
      <circle cx="100" cy="95" r="8" fill="#2D1810" />

      {/* Eyes */}
      <circle cx="85" cy="75" r="8" fill="#2D1810" />
      <circle cx="115" cy="75" r="8" fill="#2D1810" />
      <circle cx="87" cy="73" r="3" fill="white" />
      <circle cx="117" cy="73" r="3" fill="white" />

      {/* Ears */}
      <ellipse cx="65" cy="65" rx="18" ry="28" fill="#8B4513" transform="rotate(-20 65 65)" />
      <ellipse cx="135" cy="65" rx="18" ry="28" fill="#8B4513" transform="rotate(20 135 65)" />

      {/* Front Legs */}
      <rect x="70" y="165" width="15" height="30" rx="5" fill="#8B4513" />
      <rect x="115" y="165" width="15" height="30" rx="5" fill="#8B4513" />

      {/* Back Legs */}
      <rect x="60" y="170" width="15" height="25" rx="5" fill="#8B4513" />
      <rect x="125" y="170" width="15" height="25" rx="5" fill="#8B4513" />

      {/* Tail */}
      <path
        d="M 150 130 Q 170 110 165 140 Q 160 160 150 150"
        fill="#8B4513"
        stroke="#8B4513"
        strokeWidth="8"
        strokeLinecap="round"
      />
    </svg>
  )
}
